import AppDetailsModel   from 'FormDetailsModel';
import AppSimpleModel   from 'ViewableInstanceModel.js';

//Utils & libraries
import util from 'util/Util';
import _ from 'lodash';
import constants from 'Constants.js';
import Spinner from 'spin/spin';
import { Model } from 'backbone';
import mobileConstants from "../../mobile/commons/MobileFormsConstants";


//Services
import eventBus from 'EventBus.js';
import formAddService from 'FormAddService.js';
import notificationService from 'NotificationService';
import listService from 'ListService.js';
import restService from 'RestService';
import configService from 'ConfigService';
import commonService from 'CommonService.js';
import userService from "UserService.js";

//Modals
import PlayFormModal from 'common-views/PlayFormModal.js';
import CreateFormInstanceModal from 'dashboard/forms/modal/CreateFormInstanceModal.js';

//Views

import FormInstancesView from 'dashboard/forms/FormInstancesView.js';

class AppService {

    constructor() {
        configService.promise.then(config => {
            this.apiHostUrl = config.apiHostUrl;
            this.hostUrl = config.hostUrl;
        });        
    }

    createNewModel(appId, appDetailsResult, groupType) {

        const appDetailsData = appDetailsResult.RESULT.RESPONSE.PrivateFormDetails;
        const appDetailsModel = new AppDetailsModel();

        let permissionList = [];
        let dependenceList = [];

        // Adding Permissions to an array if any
        if (appDetailsData['PermissionsXML']) {
            permissionList = appDetailsData['PermissionsXML'].Permissions.User instanceof Array
                ? appDetailsData['PermissionsXML'].Permissions.User
                : [appDetailsData['PermissionsXML'].Permissions.User];
        }
        //Adding Dependencies to an array if any
        if (appDetailsData['Dependencies']) {
            let tmpDependenceList = appDetailsData['Dependencies'].Dependency instanceof Array
                ? appDetailsData['Dependencies'].Dependency
                : [appDetailsData['Dependencies'].Dependency];
            dependenceList = _.sortBy(tmpDependenceList, ['@type', '@name']);
        }

        appDetailsModel.set('ownerId', appDetailsData.OwnerId);
        appDetailsModel.set('ownerName', appDetailsData.OwnerName);

        appDetailsModel.set('formName', appDetailsData.Name);
        appDetailsModel.set('currentFormName', appDetailsData.Name);
        appDetailsModel.set('dateCreated', util.getFormattedDate(appDetailsData.CreatedDate));
        appDetailsModel.set('lastUpdate', util.getFormattedDate(appDetailsData.LastUpdate));
        appDetailsModel.set('lastUpdateUTC', util.formatUTC(appDetailsData.LastUpdate));
        appDetailsModel.set('latestVersion', appDetailsData.Version);
        appDetailsModel.set('viewedBy', permissionList);
        appDetailsModel.set('publishedVersion', appDetailsData.DeployVersion);
        appDetailsModel.set('isActive', util.isTrue(appDetailsData.IsActive));
        appDetailsModel.set('currentIsActive', util.isTrue(appDetailsData.IsActive));
        appDetailsModel.set('mobileFormIsActive', util.isTrue(appDetailsData.MobileEnabled));
        appDetailsModel.set('mobileWizardIsCompleted', util.isTrue(appDetailsData.IsWizardCompleted));
        appDetailsModel.set('mobileDesignExists', util.isTrue(appDetailsData.MobileDesignExists));

        const mobileFeatureIsEnabled = userService.checkFeatures(mobileConstants.MOBILE_ACCOUNT_VIEW);
        appDetailsModel.set('mobileFeatureIsEnabled', util.isTrue(mobileFeatureIsEnabled));
        let mobileFormIsEnabled = mobileFeatureIsEnabled && appDetailsModel.get('isActive') && appDetailsModel.get('mobileWizardIsCompleted');
        appDetailsModel.set('mobileFormIsEnabled', util.isTrue(mobileFormIsEnabled));

        appDetailsModel.set('requireLoginFromEmail', util.isTrue(appDetailsData.NotificationRequiresLogin));
        appDetailsModel.set('currentRequireLoginFromEmail', util.isTrue(appDetailsData.NotificationRequiresLogin));
        appDetailsModel.set('version', 'latest');
        appDetailsModel.set('formId', appId);

        if(appDetailsData.VersionList){
            appDetailsModel.set('versionList', appDetailsData.VersionList.Version);
        }
        
        appDetailsModel.set('ownerName', appDetailsData.OwnerName);
        appDetailsModel.set('LastRecoveryUpdateDate', appDetailsData.LastRecoveryUpdateDate);

        appDetailsModel.set('permissionList', _.cloneDeep(permissionList));

        if(appDetailsData.UserPermissionsXML){
            appDetailsModel.set('userPermissionList', appDetailsData.UserPermissionsXML.Permissions);
        }

        appDetailsModel.set('currentPermissionList', _.cloneDeep(permissionList));

        appDetailsModel.set('hasChanges', false);
        appDetailsModel.set('responsive', appDetailsData.IsResponsive);
        appDetailsModel.set('containsMobileErrors', appDetailsData.ContainsMobileErrors);
        appDetailsModel.set('dependenceList', Object.assign([], dependenceList));

        // Getting formInstances values from the API so they can be rendered on the tree
        const openAttentionInstances = appDetailsData.OpenAttentionInstances;
        const openNoAttentionInstances = appDetailsData.OpenNoAttentionInstances;
        const closedInstances = appDetailsData.ClosedInstances;
        const archivedInstances = appDetailsData.ArchivedInstances;
        const totalOpenInstances = parseInt(openAttentionInstances) + parseInt(openNoAttentionInstances);
        const totalInstances = parseInt(totalOpenInstances) + parseInt(closedInstances) + parseInt(archivedInstances);

        appDetailsModel.set('openAttentionInstances', openAttentionInstances);
        appDetailsModel.set('openNoAttentionInstances', openNoAttentionInstances);
        appDetailsModel.set('closedInstances', closedInstances);
        appDetailsModel.set('archivedInstances', archivedInstances);
        appDetailsModel.set('totalOpenInstances', totalOpenInstances);
        appDetailsModel.set('totalInstances', totalInstances);

        appDetailsModel.set('LinkId', appDetailsData.LinkId);
        appDetailsModel.set('Width', appDetailsData.Width);
        appDetailsModel.set('Height', appDetailsData.Height);
        appDetailsModel.set('IsDeployed', appDetailsData.IsDeployed);
        appDetailsModel.set('GroupId', appDetailsData.GroupId);
        appDetailsModel.set('IsPrivate', appDetailsData.IsPrivate);
        appDetailsModel.set('groupType', groupType);
        if (appDetailsData.ApiReference) {
            appDetailsModel.set('apiReference', appDetailsData.ApiReference);
        }

        appDetailsModel.set('dashboardTitle', groupType !== constants.FORMS_SHARED_GROUP_TYPE
            ? `App - ${appDetailsData.Name}` : `Shared App - ${appDetailsData.Name}`);

        const breadcrumbs = [
            { name: 'Home', route: '#forms' },
            { name: 'Apps', route: '#forms' }
        ];

        appDetailsModel.set('breadcrumbs', breadcrumbs);

        appDetailsModel.set('reflowEnabled', util.isTrue(appDetailsData.ReflowEnabled));

        return appDetailsModel;
    }

    createNewSimpleModel(id, appName, viewableDetails){
        let viewableInstanceModel = new AppSimpleModel();
      
        viewableInstanceModel.set('owner', viewableDetails.OwnerName, {silent: true});
        viewableInstanceModel.set('ownerId', viewableDetails.OwnerId, {silent: true});
        viewableInstanceModel.set('lastUpdate', viewableDetails.DeployDate, {silent: true});
        viewableInstanceModel.set('lastVersion', viewableDetails.DeployVersion, {silent: true});
        viewableInstanceModel.set('formId', id, {silent: true});
        //viewableInstanceModel.set('LinkId', viewableDetails.LinkId || this.linkId, {silent: true});
        viewableInstanceModel.set('formVersionId', viewableDetails.FormVersionId, {silent:true});

        var instances = null;
        if (viewableDetails.InstanceList) {
            instances = viewableDetails.InstanceList.Instance instanceof Array
                ? viewableDetails.InstanceList.Instance
                : [viewableDetails.InstanceList.Instance];
        }
        viewableInstanceModel.set('gridData', instances, {silent: true});
        viewableInstanceModel.set('formName', appName, {silent: true});
        // Configure Title and Breadcrumbs
        var breadcrumbs = [
            {name: 'Home', route: '#forms'},
            {name: 'Apps', route: '#forms'},
            {name: appName, route: ''}
        ];

        viewableInstanceModel.set('dashboardTitle', 'App - ' + appName);
        viewableInstanceModel.set('breadcrumbs', breadcrumbs);

        return viewableInstanceModel;
    }

    createNewApp(){
        
        const groupIdToAdd = constants.DEFAULT_GROUP_ID;
        const selectedNodeTarget = constants.EDIT_FORMS_CONTAINER;
        const selectedGroupType = constants.FORMS_PRIVATE_GROUP_TYPE;
        let selectedNodeOnTree;

        const spin = new Spinner().spin($(constants.CONTENT_ID).get(0));
        
        formAddService.newForm({ groupId: groupIdToAdd }, selectedNodeTarget, selectedNodeOnTree, selectedGroupType).then((result) => {

            commonService.getModel(result.formId, "app", this.createNewModel).then((appModel)=>{
                commonService.loadDesigner(appModel, "app");
                spin.stop();
            });

        }, (errMsg) => {
            spin.stop();
            notificationService.error(errMsg);
        });
    }

    createNewInstance(appId, model, isBasic, linkId){
       
        const newInstance = (appModel) => {

            const appLink = appModel.get('LinkId') || linkId;
            let url = appLink + '&viewForm=true' + listService.isSSO();

            if (!isBasic) {
                const versionList = appModel.get('versionList');
                const isDeployed = appModel.get('IsDeployed');

                const versionInfo = commonService.getSelectedVersionId(versionList, isDeployed, false);
             
                if (versionInfo.isDraft) {
                    const newDraft = new CreateFormInstanceModal({ model: new Model() });
                    newDraft.render().then((result) => {
                        this.openAppPlayer(appModel, url, versionInfo, (result.toLowerCase() === 'yes'));
                    }).catch(e => {

                    });

                } else {
                    this.openAppPlayer(appModel, url, versionInfo, false);
                }
            }
            else{
                this.openAppPlayer(appModel, url, null, false);
            }
        }

        if(!model){

            if(!isBasic){
                commonService.getModel(appId, "app", this.createNewModel).then((appModel)=>{
                    newInstance(appModel);
                });
            }
            else{
                commonService.getBasicModel(appId, "app", this.createNewSimpleModel).then((appModel)=>{
                    newInstance(appModel);
                });
            }
        }
        else{
            newInstance(model);
        }

        
    }

    openAppPlayer(appModel, urlid, versionInfo, redirectNotifications) {
        let instanceUrl;
        if (!versionInfo || !versionInfo.isDraft) {
            
            instanceUrl = this.hostUrl + '/player.htm?f=' + urlid;
        } else {
            instanceUrl = restService.getNewInstanceDraftLink(util.isTrue(appModel.get('reflowEnabled'))) + "&isDraft=1&linkId=" + urlid + "&formVersionId=" + versionInfo.formVersionId;
            instanceUrl = instanceUrl.replace("{0}", appModel.get('formId'));
        }

        if (redirectNotifications) {
            instanceUrl += '&redirectNotifications=true';
        }

        const attributes = { url: instanceUrl, id: urlid };
        const newPlayForm = new PlayFormModal({ model: new Model(attributes) });

        let appId = appModel.get('formId');

        newPlayForm.render().then((result) => {
            eventBus.trigger('reloadTable');
        });
    }

    appInstancesList(appId, appName) {

        let breadcrumbs = [
            {name: 'Apps', route: '#forms', id: "goToForms"},
            {name: 'Edit App', route: '#forms', id: "goToEditForms"},
            {name: appName, route: ''}
        ];

        let newFormInstancesView = new FormInstancesView({
            model: new Model({
                dashboardTitle: appName + ' - Total Instances',
                formId: appId,
                breadcrumbs: breadcrumbs,
                status:  -1 ,
                attentionLevel:"-1"
            }),
            el: constants.DASHBOARD_MAIN_PANEL,
            closed: "-1"
        });
        listService.dashboardLayout.leftPanelView.detailView = newFormInstancesView;
        listService.dashboardLayout.leftPanelView.detailView.refresh = true;
        newFormInstancesView.render();   

        const refreshButton = $('#pf-refresh-main-view'); //reset id in refresh button
        refreshButton.attr("data-appid", appId);    
    }

    openDetails(appId){
        commonService.getModel(appId, "app", this.createNewModel).then((appModel) => {
            let newFormDetails = new AppDetailsView({ model: appModel, el: constants.DASHBOARD_MAIN_PANEL });
            newFormDetails.render();
        });       
    }

    
}

const appService = new AppService();
export default appService;